import { InfoOutlineIcon } from "@chakra-ui/icons";
import {
    Box,
    Checkbox,
    Flex,
    Heading,
    SimpleGrid,
    Text,
    useColorModeValue
} from "@chakra-ui/react";
import visualStyleMap from '../../utils/visualStylesMap.json'

function VideoPreviews({ previewData, selectedPreviews, onSelectedPreviews }) {

    const previewVideoBorder = useColorModeValue('#40225f', '#fe72ff');

    return (
        <Box width="700px" display={'flex'} flexDirection={'column'} gap={6}>
            <Flex direction={'column'} gap={2}>
                <Heading fontSize="xl">{`${previewData?.previews?.length} videos are generated! Select one or more to render`}</Heading>
                <Flex alignItems={'center'} gap={2}>
                    <InfoOutlineIcon boxSize={4} />
                    <Text fontSize={'12px'}>Accurate lip sync will be available after rendering</Text>
                </Flex>
            </Flex>
            <Box maxH="460px" overflowY="auto" p={2}>
                <SimpleGrid columns={[1, 2, 3]} spacing={4}>
                    {previewData?.previews?.map((preview, index) => {

                        return (
                            <Box>
                                <Box mb={2} pl={1}>
                                    <Text fontSize="xs" fontWeight="bold">
                                        {visualStyleMap[preview.visual_style] || preview.visual_style}
                                    </Text>
                                </Box>
                                <Box
                                    key={index}
                                    role="group"
                                    overflow="hidden"
                                    position="relative"
                                    p={1}
                                    borderRadius="12px"
                                    border={'2px solid transparent'}
                                    _hover={{ shadow: "md", cursor: "pointer", border: `2px solid ${previewVideoBorder}` }}
                                >
                                    <>
                                        <Box borderRadius="8px" overflow="hidden">
                                            <iframe
                                                src={preview.url}
                                                width="100%"
                                                height="350"
                                                frameborder="0"
                                                allowfullscreen
                                            >
                                            </iframe>
                                        </Box>
                                        <Checkbox
                                            position="absolute"
                                            top="10px"
                                            left="10px"
                                            isChecked={selectedPreviews.includes(preview?.media_job)}
                                            onChange={() => onSelectedPreviews(preview?.media_job)}
                                            colorScheme='brand'
                                            zIndex="2"
                                            bg="#fff"
                                            border="1px solid"
                                            borderRadius="4px"
                                            boxShadow="md"
                                            padding="2px"
                                        />
                                    </>
                                </Box>
                            </Box>
                        );
                    })}
                </SimpleGrid>
            </Box>
        </Box>
    )
}

export default VideoPreviews;
